var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('Main', {
    attrs: {
      "type": _vm.type,
      "headers": _vm.headers
    },
    on: {
      "view-info": _vm.viewInfo,
      "get-status-count": _vm.getStatusCount
    }
  });
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };